import { render, staticRenderFns } from "./PointCreditTelecomComplete.vue?vue&type=template&id=0203658d"
import script from "./PointCreditTelecomComplete.vue?vue&type=script&lang=js"
export * from "./PointCreditTelecomComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports